export default "__VITE_ASSET__tkyehL0D__"